export default "__VITE_ASSET__DBBe14eQ__"